import {Grid} from '@mui/material'
import {useEffect, useState} from 'react'
import {useCompany} from 'src/contexts/CompanyContext'
import useGetSyntheticData from 'src/hooks/api/personalized-dashboard/useGetSyntheticData'
import CardToTables from 'src/pages/dashboard/components/CardToTables'
import {RangeOfDates} from 'src/pages/dashboard/components/PersonalizedDatesRange'

type Props = {
  filter: RangeOfDates
  labelOnFilter: string
}

const LabelOnFilterToShowOnColumn: {[x: string]: string} = {
  Semanal: 'Semana Passada',
  Mensal: 'Mês Passado',
  Anual: 'Ano Passado',
}

export default function SyntheticDashboard({filter, labelOnFilter}: Props) {
  const {selectedCompanyId} = useCompany()

  const {data, isLoading, isRefetching} = useGetSyntheticData({range: filter, filter: {companyIds: [selectedCompanyId]}})
  const [columnName, setColumnName] = useState<string>('Ano Passado')

  const handleNameOnColumn = () => {
    const name = LabelOnFilterToShowOnColumn[labelOnFilter]
    setColumnName(name)
  }

  useEffect(() => {
    handleNameOnColumn()
  }, [labelOnFilter])

  const handleFooterValues = () => {
    let totalValue = 0
    let totalLastYear = 0
    let totalPercentage = 0
    let totalDelta = 0

    data?.forEach((it) => {
      totalValue += it.actualResult
      totalLastYear += it.lastResult ?? 0
      totalPercentage += it.percentage ? Number(it.percentage.toFixed(2)) : 0
      totalDelta += it.delta ?? 0
    })

    return {totalValue, totalLastYear, totalPercentage, totalDelta}
  }

  return (
    <Grid container gap={'40px'} padding={'0 20px'}>
      <Grid item container xs={12} spacing={'32px'}>
        <Grid item container xs={12} lg={6}>
          <CardToTables
            title={'Visitantes'}
            loading={isLoading}
            refetching={isRefetching}
            nameOnColumn={columnName}
            rows={data}
            footerValues={handleFooterValues()}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
